<template>
  <v-menu close-on-content-click
          open-on-hover offset-y
          close-delay="300">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="normal-btn-text body-1 font-weight-bold ml-3"
        v-on="on"
      >
        Gestão de frete
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        link
        :disabled="!hasModuleGestorFrete"
        to="/cotacoes-fretes"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-truck-fast</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Cotações de fretes</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :disabled="!hasModuleGestorFrete"
        to="/contratacoes-fretes"
        active-class="orange--text"
      >
        <v-list-item-icon>
          <v-icon>mdi-truck-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">Contratações de fretes</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['user', 'hasModuleGestorFrete']),
  },
};
</script>
